import { EnumCommercialRelationActionType } from '../../../api/oData/enums/enumCommercialRelationActionType'
import { CommercialFormModel } from './commercials.details'

export const validateForContract = (
  commercial: CommercialFormModel,
  commercials: CommercialFormModel[],
  commercialID?: number
) => {
  let allowLinkAllContracts = true
  let allowLinkAllProducts = true

  if (!commercial.contractId) {
    return { allowLinkAllContracts, allowLinkAllProducts }
  }

  if (
    commercials.some(
      c =>
        c.relationLevel === EnumCommercialRelationActionType.Contract &&
        c.contractId === commercial.contractId &&
        (commercial?.id ? c.id !== commercialID : true)
    )
  ) {
    allowLinkAllContracts = false
    allowLinkAllProducts = false
  }

  return { allowLinkAllContracts, allowLinkAllProducts }
}

export const validateForProduct = (
  commercial: CommercialFormModel,
  commercials: CommercialFormModel[],
  commercialID?: number
) => {
  let allowLinkAllContracts = true
  let allowLinkAllProducts = true

  if (!commercial.contractId) {
    return { allowLinkAllContracts, allowLinkAllProducts }
  }

  if (
    commercials.some(
      c =>
        c.relationLevel === EnumCommercialRelationActionType.Product &&
        c.contractId === commercial.contractId &&
        c.contractProductId &&
        (commercial?.id ? c.id !== commercialID : true)
    )
  ) {
    allowLinkAllContracts = false
    allowLinkAllProducts = false
  }

  return { allowLinkAllContracts, allowLinkAllProducts }
}
